const apiUrl = {
	// url: "http://localhost:37792"
	url: "http://hrtest.egiraffe.com.cn"
	//url: "http://211.152.36.22:8090"
}
export default apiUrl;




// WEBPACK FOOTER //
// ./src/utils/api-url.js